import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

const ActionButton = ({
  actionObj,
  handleValue,
  darkButton = false,
  id,
  manageId,
  disabled = false,
}) => {
  return (
    <Fragment>
      {actionObj && actionObj.link ? (
        <Link
          to={{
            pathname:
              id !== undefined
                ? `${actionObj.link}` || "#"
                : `${actionObj.link}` || "#",
            item: actionObj,
          }}
          className={`btn ${darkButton ? "btn-primary" : "btn-transparent"}`}
          onClick={() => handleValue(actionObj)}
        >
          {actionObj.name}
        </Link>
      ) : (
        <Button
          className={`btn ${darkButton ? "btn-primary" : "btn-transparent"}`}
          onClick={() => handleValue(actionObj)}
          disabled = {disabled}
        >
          {actionObj.name}
        </Button>
      )}
    </Fragment>
  );
};

export default ActionButton;
